import { render, staticRenderFns } from "./TrainingDataStudent.vue?vue&type=template&id=4a235bca&scoped=true&"
import script from "./TrainingDataStudent.vue?vue&type=script&lang=js&"
export * from "./TrainingDataStudent.vue?vue&type=script&lang=js&"
import style0 from "./TrainingDataStudent.vue?vue&type=style&index=0&id=4a235bca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a235bca",
  null
  
)

export default component.exports